// extracted by mini-css-extract-plugin
var _1 = "LabelEntityAssignmentsConfirmationModal-moduleradioContainer__Kg8Eu Radio-modulecontainer__Fpyy8";
var _2 = "LabelEntityAssignmentsConfirmationModal-moduleradioLabel__v5Bwb Radio-modulelabel__Ucl1L";
export { _1 as "radioContainer", _2 as "radioLabel" }
